<template>
  <div class="page-content">
    <page-template
      ref="deposit"
      :tableOptions="tableOptions"
      :toolConfig="toolConfig"
      :searchOptions="searchOptions"
      @searchReset="searchReset"
    >
    </page-template>
  </div>
</template>

<script>
import api from "@/config/api";
import pageTemplate from "@/components/template/pageTemplate";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {pageTemplate},
  data() {
    return {
      indexShow: false,
      // 更多功能
      toolConfig: [
        {
          label: '导出',
          code: 'export',
          callback: this.export,
        },
      ],
      searchOptions: {
        simple: [
          // {
          //   label: '会员ID',
          //   prop: 'mbMemberId',
          //   type: 'input',
          //   span: 8,
          // },
          {
            label: '会员姓名/手机号/卡号',
            prop: 'memberName',
            type: 'input',
            span: 24,
            placeholder: "请输入会员姓名/手机号/卡号",
          },
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          // {
          //   label: '会员ID',
          //   prop: 'mbMemberId',
          //   type: 'input',
          //   span: 8,
          // },
          {
            label: "会员手机号",
            prop: "memberPhone",
            type: "input",
            span: 8,
          },
          {
            label: "会员类别",
            prop: "memberCategoryId",
            type: "select",
            span: 8,
            data: [],
            url: api.member.category,
          },
          // {
          //   label: "消费分店",
          //   prop: "consumeStoreId",
          //   type: "select",
          //   span: 8,
          //   data:[],
          //   url:api.store.storeList
          // },
          // {
          //   label: "导购员",
          //   prop: "guideName",
          //   type: "input",
          //   span: 8,
          // },
          // {
          //   label: "收银员",
          //   prop: "cashierName",
          //   type: "input",
          //   span: 8,
          // },

          {
            label: "发卡门店",
            prop: "cardStoreId",
            type: "select",
            span: 8,
            data: [],
            isHasAll: true,
            url: api.system.seStore,
          },
          {
            label: "消费门店",
            prop: "consumeStoreId",
            type: "select",
            span: 8,
            data: [],
            isHasAll: true,
            change: this.storeChange,
            url: api.system.seStore,
          },
          {
            label: "导购员",
            type: "select",
            prop: "guideId",
            data: [],
            span: 8,
            // url: api.system.account,
            // param: {type: 50},
          },
          {
            label: "收银员",
            type: "select",
            prop: "cashierId",
            data: [],
            span: 8,
            // param: {type: 40},
            // url: api.system.account,
          },
          {
            label: "消费金额区间",
            prop: "TotalPrice",
            type: "numberRange",
            span: 24,
          },
        ],
      },
      tableOptions: {
        showSummary: true,
        summaryColumns: ['amountReceived'],
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "消费单号",
            prop: "orderNo",
            align: "center",
            width: "220"
          },
          {
            label: "消费门店",
            prop: "consumeStoreName",
            align: "center",
            width: "220"
          },
          {
            label: "消费时间",
            prop: "lastModifyDttm",
            align: "center",
            width: "160"
          },
          {
            label: "消费金额",
            prop: "amountReceived",
            align: "center",
            width: "90",
          },
          {
            label: "收银员",
            prop: "cashierName",
            align: "center",
            width: "100"
          },
          {
            label: "导购员",
            prop: "guideName",
            align: "center",
            width: "100"
          },
          {
            label: "PLUS会员",
            prop: "plusStatus",
            align: "center",
            width: "120",
            enumData: this.$utils.getCacheStatus("mbMember.plusStatus")
          },
          {
            label: "手机号",
            prop: "memberPhone",
            align: "center",
            width: "120"
          },
          {
            label: "姓名",
            prop: "memberName",
            align: "center",
            width: "120"
          },
          {
            label: "会员卡号",
            prop: "memberCardNum",
            align: "center",
            width: "120"
          },
          {
            label: "会员类别",
            prop: "memberCategoryName",
            align: "center",
            width: "80"
          },

        ],
        url: api.member.meberRecord
      },
    };
  },
  created() {
    // this.setStore(this.searchOptions.complex);
    // this.getCashGuide()
  },
  mounted() {
  },
  methods: {
    // 门店身份 默认数据
    // getCashGuide(){
    //   let userInfo = this.$utils.getSysUser()
    //   if(userInfo.storeId){
    //     this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: userInfo.storeId}).then(data => {
    //       if (data.code === 200) {
    //         this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
    //       }
    //     });
    //     this.$axios.fetchPost(api.system.guide + '/list', {storeId: userInfo.storeId, type: 50}).then(data => {
    //       if (data.code === 200) {
    //         this.searchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
    //       }
    //     })
    //   }
    // },
    // 重置
    searchReset() {
      this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
      this.searchOptions.complex.filter(item => item.prop === 'guideId')[0].data = []
    },
    // 高级搜索选择门店 联动
    storeChange(form) {
      form.cashierId = '';
      form.guideId = '';
      let storeId = form.consumeStoreId
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.system.guide + '/list', {storeId: storeId, type: 50}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
        }
      })
    },
    export() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["deposit"].getCurrentParams();
      this.$axios.PostBlob(api.member.meberRecordExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '会员消费记录_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          // this.$message.success("导出成功,文件名称:" + fileName);
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  },
};
</script>

<style scoped>
.page-template {
  padding-top: 0;
}

.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}

.page-template .echartsArea {
  height: 270px;
  margin-bottom: 12px;
}

</style>



// WEBPACK FOOTER //
// src/page/member/consume/record.vue